import { render, staticRenderFns } from "./ResearcherBasics.vue?vue&type=template&id=c9b513b4"
import script from "./ResearcherBasics.vue?vue&type=script&lang=js"
export * from "./ResearcherBasics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports